import SEO from '@/components/SEO';
import usePageContent from '@/lib/usePageContent';

export default function MediaKitPage() {
  const content = usePageContent('media_kit');
  const downloadUrl = content.download_url || '/media/Kalamanch_Media_Kit_v1.0.pdf';
  const downloadLabel = content.download_label || 'Download Media Kit';
  const startupRecognitionLine = 'KalaManch.art is a product of Tivaro LLP, recognized by DPIIT under the Startup India initiative, Government of India, and recognized as a startup by the Department of IT & Electronics, Government of Uttar Pradesh.';
  const sections = [
    {
      title: 'Brand Overview',
      body: `KalaManch.art is an AI-powered platform connecting Indian artists, performers and creators through portfolios, collaborations and creative opportunities. ${startupRecognitionLine}`,
    },
    {
      title: 'Mission',
      body: 'To help artists across India showcase talent, connect creatively and grow without barriers.',
    },
    {
      title: 'AI Studio',
      body: 'KalaManch.art offers AI-powered creator tools including caption generation, portfolio writing, reel ideas, hashtags and promotional content support.',
    },
    {
      title: 'Community Focus',
      body: 'Supporting creators across cities, towns and regional art communities throughout India.',
    },
  ];
  const features = ['Artist portfolios', 'Collaboration discovery', 'Opportunity sharing', 'Talent reels', 'AI Studio tools', 'Direct enquiries', 'Verified profiles'];

  return (
    <main className="min-h-screen bg-[#f7f9fc] pt-28">
      <SEO
        title="KalaManch Media Kit"
        description="Download the KalaManch media kit and learn about the artist discovery platform, mobile app, and AI Studio tools."
        keywords="KalaManch media kit, artist platform media, Kalamanch press kit"
      />
      <section className="mx-auto max-w-5xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-sm font-bold uppercase tracking-[0.24em] text-[#FF6F00]">Media Kit</p>
        <h1 className="mt-4 text-4xl font-extrabold text-gray-950 sm:text-6xl">{content.hero_title || 'KalaManch Media Kit'}</h1>
        <p className="mt-6 max-w-3xl text-lg leading-8 text-gray-650">
          {content.hero_subtitle || 'A simple resource for partners, press, collaborators, institutions, and artists who want to understand KalaManch.Art.'}
        </p>
        <div className="mt-8 rounded-[2rem] border border-orange-100 bg-white p-6 shadow-xl">
          <p className="whitespace-pre-wrap text-base leading-8 text-gray-700">
            {content.body || 'The media kit includes KalaManch positioning, platform details, launch context, and useful brand information. Admin can update this page and the download link from Content & SEO.'}
          </p>
          <p className="mt-5 rounded-2xl border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm font-bold leading-6 text-emerald-800">
            {startupRecognitionLine}
          </p>
          <a
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex rounded-full bg-[#FF6F00] px-6 py-3 text-sm font-bold text-white shadow-lg transition hover:bg-[#E65100]"
          >
            {downloadLabel}
          </a>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {sections.map((section) => (
            <section key={section.title} className="rounded-[1.5rem] border border-gray-200 bg-white p-6 shadow-sm">
              <h2 className="text-2xl font-bold text-gray-950">{section.title}</h2>
              <p className="mt-3 text-base leading-7 text-gray-650">{section.body}</p>
            </section>
          ))}
        </div>

        <section className="mt-8 rounded-[1.5rem] border border-gray-200 bg-white p-6 shadow-sm">
          <h2 className="text-2xl font-bold text-gray-950">Platform Features</h2>
          <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {features.map((feature) => (
              <span key={feature} className="rounded-full border border-orange-100 bg-orange-50 px-4 py-2 text-sm font-bold text-gray-800">
                {feature}
              </span>
            ))}
          </div>
        </section>

        <section className="mt-8 rounded-[1.5rem] border border-emerald-100 bg-emerald-50 p-6">
          <h2 className="text-2xl font-bold text-gray-950">Press Enquiries</h2>
          <p className="mt-3 text-base leading-7 text-gray-700">
            For partnerships, interviews and collaborations, contact the KalaManch.art team.
          </p>
          <a href="mailto:me@kalamanch.art" className="mt-4 inline-flex rounded-full bg-emerald-700 px-5 py-3 text-sm font-bold text-white">
            me@kalamanch.art
          </a>
        </section>
      </section>
    </main>
  );
}
